<template>
	<div class="container__crud">
		<div class="container__crudactions">
			<div class="container__crudactions__cruddownload">
				<div class="container__crudactions__cruddownload__crud">
					<Button
						:label="$t('deleteSelected')"
						color="trv-error"
						outlined
						icon="far fa-trash-alt"
						semantic-class="tiny"
						:disabled="isDeleteButtonDisabled"
						width-auto
						@click="toggleExclusionAlert"
					/>
					<Button
						:label="$t('create')"
						color="trv-default"
						semantic-class="tiny"
						width-auto
						@click="showNewModelForm"
					/>
					<ExclusionAlert
						v-if="showExclusionAlert"
						:items-to-delete="modelList.filter((item) => item.isCheckedToDelete)"
						@cancel="toggleExclusionAlert"
						@confirm="deleteModels"
					>
						<template #item="{ item }">
							<li class="exclusion-alert-item">
								{{ $t('code') }} : {{ item.tpsl_cd_codigo }} - {{ $t('acronym') }} :
								{{ item.tpsl_nm_sigla }}
							</li>
						</template>
					</ExclusionAlert>
				</div>
				<!-- <div class="container__crudactions__cruddownload__download">
          <DownloadButton />
        </div> -->
			</div>
			<div class="container__crudactions__filtercollums">
				<div class="container__crudactions__filtercollums__filter">
					<InputSearch
						v-model="textFilter"
						style="margin-right: 0.5rem"
						:placeholder="$t('search')"
					/>
				</div>
				<div
					class="container__crudactions__filtercollums__collumns"
					style="display: flex"
				>
					<DropdownCheckbox
						v-model="tableHeaders"
						style="width: 85px; right: 4px"
					/>
					<Button
						:label="$t('export')"
						semantic-class="mini"
						color="trv-primary"
						outlined
						style="border-radius: 5px !important; width: 65px"
						@click="downloadCSVSolo()"
					/>
				</div>
			</div>
		</div>
		<CrudTable
			:headers="headersAtivos"
			:data="modelsToBeShowedAndTotal.items"
			:table-configuration="tableConfiguration"
			:show-edit-model-form="showEditModelForm"
			@sortConfig="
				sortBy = $event.sortBy
				sortType = $event.sortType
			"
		>
			<template #outer-action-button="dataObject">
				<KebabMenu
					v-model="intention"
					:options="kebabOptions"
					:properties="dataObject"
				/>
			</template>
		</CrudTable>
		<div class="container__crud__pagination">
			<Pagination
				ref="ref__pagination"
				:quantity-per-page="10"
				:quantity-per-page-options="[10, 20, 30]"
				:total-records="modelsToBeShowedAndTotal.total"
				@setStartEnd="setStartEnd"
				@setQuantityPerPage="setQuantityPerPage"
			/>
		</div>
		<CrudForm
			:is-visible="showForm"
			:change-is-visible="changeFormAndCloseAllActions"
			:title-form="titleForm"
			:backdrop="true"
		>
			<template #form>
				<div style="display: flex; gap: 0.5rem; flex-direction: column">
					<InputText
						v-model="model.tpsl_nm_sigla"
						:label="$t('acronym') + '*'"
					/>
					<!-- <Accordion
            :label="$t('optionalFields')"
            :hints="[$t('description'), $t('firstCategoricLevel'), $t('secondCategoricLevel')]"
          > -->
					<div style="display: flex; gap: 0.5rem; flex-direction: column">
						<InputText
							v-model="model.tpsl_ds_descricao"
							:label="$t('description')"
						/>
						<InputText
							v-model="model.tpsl_nm_nivel1"
							:label="$t('firstCategoricLevel')"
						/>
						<InputText
							v-model="model.tpsl_nm_nivel2"
							:label="$t('secondCategoricLevel')"
						/>
						<InputText
							v-model="model.tpsl_nm_nivel3"
							:label="$t('thirdCategoricLevel')"
						/>
					</div>
					<!-- </Accordion> -->
				</div>

				<div class="container__crud__crudform__buttons">
					<Button
						:label="$t('save')"
						color="trv-default"
						semantic-class="mini"
						:disabled="disableSaveButton || !camposObrigatoriosPreenchidos"
						@click="saveClick()"
					/>
					<Button
						:label="$t('cancel')"
						color="trv-default"
						semantic-class="mini"
						outlined
						@click="changeFormAndCloseAllActions"
					/>
				</div>
			</template>
		</CrudForm>
	</div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'

import Button from '../../../../components/Button/Button'
import CrudForm from '../../../../components/CrudForm/CrudForm'
import CrudTable from '../../../../components/CrudTable/CrudTable'
import DropdownCheckbox from '../../../../components/DropdownCheckbox/DropdownCheckbox'
import InputSearch from '../../../../components/InputSearch/InputSearch'
import InputText from '../../../../components/InputText/InputText'
import KebabMenu from '../../../../components/KebabMenu/KebabMenu'
import Pagination from '../../../../components/Pagination/Pagination'

import ControllingPaginationMixins from '../../../../mixins/ControllingPaginationMixins'
import RegistersMixins from '../../../../mixins/RegistersMixins'

import {
	createSolo,
	deleteSoloByIdList,
	getAllSolos,
	updateSolo,
} from '../../../../services/requests/SoloRequests'

import validarSolo from '../../../../validations/SoloValidation'
import download from 'downloadjs'
import ExclusionAlert from '../../../../components/ExclusionAlert/ExclusionAlert.vue'

export default {
	components: {
		Button,
		CrudForm,
		CrudTable,
		KebabMenu,
		DropdownCheckbox,
		InputSearch,
		InputText,
		Pagination,
		ExclusionAlert,
	},
	/**
	 * Mixins
	 * - ControllingPaginationMaxins: Mixin para controler a paginacao
	 * - RegistersMixins: Mixin com funções compartilhadas para realizar o CRUD
	 */
	mixins: [ControllingPaginationMixins, RegistersMixins],
	data() {
		return {
			intention: {},
			headersSelecionados: ['tpsl_nm_nivel2', 'tpsl_nm_nivel1', 'tpsl_nm_sigla', 'tpsl_cd_codigo'],
			showExclusionAlert: false,
			/**
			 * Campos que devem ser feito bind para cadastro ou edicao de registro
			 */
			model: {
				id: '',
				tpsl_cd_codigo: '',
				tpsl_ds_descricao: '',
				tpsl_nm_nivel1: '',
				tpsl_nm_nivel2: '',
				tpsl_nm_nivel3: '',
				tpsl_nm_sigla: '',
			},
			/**
			 * Configuração da tabela
			 */
			tableConfiguration: {
				statusTable: this.$t('loading') + '...',
				subtitleCardPropertie: 'tpsl_ds_descricao',
				titleCardPropertie: 'tpsl_nm_sigla',
			},
			tableHeaders: [
				{ key: 'tpsl_nm_sigla', value: this.$t('acronym'), isActive: true },
				{
					key: 'tpsl_nm_nivel1',
					value: this.$t('firstLevel'),
					isActive: true,
				},
				{
					key: 'tpsl_nm_nivel2',
					value: this.$t('secondLevel'),
					isActive: true,
				},
				{
					key: 'tpsl_nm_nivel3',
					value: this.$t('thirdLevel'),
					isActive: false,
				},
				{
					key: 'tpsl_ds_descricao',
					value: this.$t('description'),
					isActive: false,
				},
			],
		}
	},
	computed: {
		kebabOptions() {
			return [
				{
					value: 'editar',
					label: this.$t('edit'),
				},
			]
		},
		headersAtivos() {
			const ativos = this.tableHeaders.filter((f) => this.headersSelecionados.includes(f.key))

			ativos.forEach((f) => {
				f.isActive = true
			})

			return ativos
		},
		/**
		 * Retorna se os campos obrigatórios estão preenchidos
		 */
		camposObrigatoriosPreenchidos() {
			return this.model.tpsl_nm_sigla
		},
	},
	watch: {
		tableHeaders: {
			deep: true,
			handler(value) {
				this.headersSelecionados = value.filter((f) => f.isActive).map((m) => m.key)
			},
		},
		intention(value) {
			const model = this.modelList.find((model) => model.id === value.properties.id)

			switch (value.intent) {
				case 'editar':
					this.showEditModelForm(model)
					break
			}
		},
	},
	/**
	 * Antes de criar o objeto seta a quantidade de itens por pagina
	 * e a ordenacao da tabela
	 */
	created() {
		this.quantityPerPage = 10
		this.orderTable = ['ptio_cd_codigo']
		getAllSolos().then((response) => {
			const { result } = response.data
			result.forEach((f) => (f.isCheckedToDelete = false))
			this.modelList = result
			this.tableConfiguration.statusTable = this.$t('noRecordFound')
		})
	},
	methods: {
		/**
		 * Cria o objeto que deve ser enviado para o backend para ser
		 * criado no banco de dados
		 */
		toggleExclusionAlert() {
			this.showExclusionAlert = !this.showExclusionAlert
		},
		createModelToPost() {
			return {
				id: uuidv4(),
				tpsl_ds_descricao: this.model.tpsl_ds_descricao,
				tpsl_nm_nivel1: this.model.tpsl_nm_nivel1,
				tpsl_nm_nivel2: this.model.tpsl_nm_nivel2,
				tpsl_nm_nivel3: this.model.tpsl_nm_nivel3,
				tpsl_nm_sigla: this.model.tpsl_nm_sigla,
			}
		},

		downloadCSVSolo() {
			let cabecalhoDoCsvSolo = ['Sigla', '1º Nível', '2º Nível ', '3º Nível ', 'Descrição']
			const items = this.modelList

			const csv = [
				cabecalhoDoCsvSolo,
				...items.map((item) => [
					item.tpsl_nm_sigla,
					item.tpsl_nm_nivel1,
					item.tpsl_nm_nivel2,
					item.tpsl_nm_nivel3,
					item.tpsl_ds_descricao,
				]),
			]
				.map((m) => m.join(';'))
				.join('\r\n')

			download(csv, 'export_solo.csv', 'text/csv')
		},

		/**
		 * Seta fk de talhao no model vinda do dropdown
		 */
		setTalhao(value) {
			this.model.fk_tlho_talhao = value
		},

		/**
		 * Seta fk de Estrato florestal no model vinda do dropdown
		 */
		setEstratoFlorestal(value) {
			this.model.fk_esfl_estrato_florestal = value
		},

		/**
		 * Seta fk de Material genético no model vinda do dropdown
		 */
		setMaterialGenetico(value) {
			this.model.fk_mtge_material_genetico = value
		},

		/**
		 * Cria novo Solo no banco de dados
		 */
		create() {
			const solo = this.createModelToPost()
			const { isValid } = validarSolo(solo, this.modelList)

			if (isValid) {
				createSolo(solo).then((response) => {
					const { result: solo, isError } = response.data
					this.disableSaveButton = false

					if (!isError) {
						this.cleanModel()
						solo.isCheckedToDelete = false
						this.modelList.unshift(solo)

						this.showForm = false
						this.emptyValue = ''

						this.mutationShowMessage({
							messageTitle: this.$t('sucesso'),
							messageIcon: 'far fa-check-circle',
							messageType: 'success',
						})
					} else {
						this.mutationShowMessage({
							messageTitle: this.$t('erro'),
							messageIcon: 'far fa-check-circle',
							messageType: 'error',
						})
					}
				})
			} else {
				this.disableSaveButton = false
				this.mutationShowMessage({
					messageTitle: this.$t('erro'),
					messageIcon: 'far fa-check-circle',
					messageType: 'error',
				})
			}
		},

		/**
		 * Atualiza fazenda no banco de dados
		 */
		update() {
			updateSolo(this.model).then((response) => {
				const { result: model, isError } = response.data
				this.disableSaveButton = false

				if (!isError) {
					model.isCheckedToDelete = false

					const indexModel = this.modelList.map((m) => m.id).indexOf(this.model.id)
					this.$set(this.modelList, indexModel, model)

					this.showForm = false

					this.mutationShowMessage({
						messageTitle: this.$t('sucesso'),
						messageIcon: 'far fa-check-circle',
						messageType: 'success',
					})
				} else {
					this.mutationShowMessage({
						messageTitle: this.$t('erro'),
						messageIcon: 'far fa-check-circle',
						messageType: 'error',
					})
				}
			})
		},

		/**
		 * Exclui fazenda no banco de dados
		 */
		deleteModels(email) {
			var emailUsuario = localStorage.getItem('email')
			if (email === emailUsuario) {
				const existeRegistroComDependencia = this.modelList.filter(
					(tipoDeSolo) =>
						this.modelsIdWithCheckedToDelete.includes(tipoDeSolo.id) &&
						tipoDeSolo.possuiDependenciaDeRegistro,
				)
				if (existeRegistroComDependencia.length == 0) {
					const confirmResult = confirm('Deseja realmente excluir esses registros?')

					if (confirmResult) {
						deleteSoloByIdList(this.modelsIdWithCheckedToDelete).then(() => {
							this.modelsIdWithCheckedToDelete.forEach((f) => {
								const indexToRemove = this.modelList.map((m) => m.id).indexOf(f)
								this.modelList.splice(indexToRemove, 1)
							})

							this.mutationShowMessage({
								messageTitle: this.$t('sucesso'),
								messageIcon: 'far fa-check-circle',
								messageType: 'success',
							})
							this.showExclusionAlert = false
						})
					}
				} else {
					var tipoDeSoloOrganizado = existeRegistroComDependencia
						.map((tipoDeSolo) => `• TS-${tipoDeSolo.tpsl_cd_codigo} - ${tipoDeSolo.tpsl_nm_sigla}`)
						.join('<br/>')
					var message = `<b>${this.$t('soloAtreladoATalhao')}:</b> <br/><br/> ${tipoDeSoloOrganizado}`
					this.mutationShowMessage({
						messageTitle: this.$t('cuidado'),
						messageText: message,
						messageIcon: 'fas fa-exclamation-circle',
						messageType: 'warning',
					})
				}
			} else {
				this.mutationShowMessage({
					messageTitle: this.$t('wrongEmail'),
					messageIcon: 'fas fa-lock',
					messageType: 'error',
					messageText: this.$t('wrongEmaildescricao'),
				})
			}
		},

		/**
		 * Método executado quando clica no botão de salvar
		 */
		saveClick() {
			this.disableSaveButton = true
			if (this.isEdit) {
				this.update()
			} else {
				this.create()
			}
		},

		/**
		 * Configura para exibir o Model de edicao
		 */
		showEditModelForm(model) {
			this.model = Object.assign({}, model)

			this.titleForm = `${this.$t('edit')} ${this.$t('soil')}`
			this.isEdit = true
			this.changeFormAndCloseAllActions()
		},

		/**
		 * Configura para exibir o Model de Cadastro
		 */
		showNewModelForm() {
			this.cleanModel()

			this.titleForm = `${this.$t('create')} ${this.$t('soil')}`
			this.isEdit = false
			this.changeFormAndCloseAllActions()
		},

		/**
		 * Fecha o formulario e actions que estiverem abertas
		 */
		changeFormAndCloseAllActions() {
			this.showForm = !this.showForm
		},
	},
}
</script>

<style scoped src="../../../../css/crud.css"></style>
